import React from "react";

const Logo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="85"
    height="34"
    viewBox="0 0 85 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M82.4098 1.92L78.5798 21.66H4.35979L8.18979 1.92H82.4098ZM84.7598 0H6.58979L2.27979 22.28L2.02979 23.57H80.1998L84.7598 0Z"
      fill="currentColor"
    />
    <path
      d="M9 26.39L7.7 33.01H5.97L6.65 29.52L4.45 32.36H3.62L2.42 29.52L1.72 33.01H0L1.32 26.39H2.84L4.39 30.22L7.4 26.39H9Z"
      fill="currentColor"
    />
    <path
      d="M11.4201 32.85C11.0001 32.66 10.6901 32.38 10.4701 32.02C10.2501 31.66 10.1401 31.24 10.1401 30.75C10.1401 30.55 10.1601 30.31 10.2201 30.05L10.9601 26.38H12.8301L12.1001 30.02C12.0601 30.21 12.0401 30.38 12.0401 30.54C12.0401 31.23 12.4101 31.58 13.1401 31.58C13.5401 31.58 13.8501 31.46 14.0801 31.22C14.3101 30.98 14.4801 30.58 14.5901 30.02L15.3201 26.38H17.1601L16.4101 30.13C16.0101 32.13 14.8401 33.13 12.9001 33.13C12.3301 33.14 11.8401 33.04 11.4201 32.85Z"
      fill="currentColor"
    />
    <path
      d="M20.0998 27.87H18.0698L18.3698 26.39H24.2998L23.9998 27.87H21.9798L20.9498 33H19.0798L20.0998 27.87Z"
      fill="currentColor"
    />
    <path
      d="M28.7702 31.72H25.9502L25.1802 33.01H23.2002L27.4502 26.39H29.2902L30.8902 33.01H29.0302L28.7702 31.72ZM28.4902 30.34L28.0502 28.19L26.7802 30.34H28.4902Z"
      fill="currentColor"
    />
    <path
      d="M39.7101 26.39L38.3901 33.01H36.8501L34.6701 29.38L33.9401 33.01H32.1001L33.4201 26.39H34.9601L37.1501 30.01L37.8701 26.39H39.7101V26.39Z"
      fill="currentColor"
    />
    <path
      d="M42.82 27.87H40.79L41.09 26.39H47.02L46.72 27.87H44.7L43.67 33H41.8L42.82 27.87Z"
      fill="currentColor"
    />
    <path
      d="M55.2302 31.72H52.4102L51.6402 33.01H49.6602L53.9102 26.39H55.7502L57.3502 33.01H55.5002L55.2302 31.72ZM54.9502 30.34L54.5102 28.19L53.2402 30.34H54.9502Z"
      fill="currentColor"
    />
    <path
      d="M64.6698 26.95C65.1398 27.32 65.3698 27.85 65.3698 28.52C65.3698 29.07 65.2398 29.56 64.9698 29.98C64.6998 30.4 64.3198 30.72 63.8298 30.94C63.3298 31.17 62.7598 31.28 62.0998 31.28H60.7798L60.4398 33.01H58.5698L59.8898 26.39H62.6898C63.5398 26.39 64.1998 26.57 64.6698 26.95ZM63.1398 29.51C63.3598 29.31 63.4798 29.04 63.4798 28.68C63.4798 28.41 63.3898 28.21 63.2098 28.07C63.0298 27.93 62.7698 27.87 62.4398 27.87H61.4598L61.0698 29.81H62.1898C62.5998 29.8 62.9198 29.7 63.1398 29.51Z"
      fill="currentColor"
    />
    <path
      d="M68.9701 27.83L68.7501 28.95H71.6901L71.4201 30.35H68.4701L68.2301 31.56H71.7001L71.4001 33.01H66.1001L67.4201 26.39H72.6001L72.3101 27.84H68.9701V27.83Z"
      fill="currentColor"
    />
    <path
      d="M74.0198 32.94C73.5298 32.81 73.1298 32.64 72.8198 32.43L73.5598 31.03C73.8898 31.24 74.2498 31.41 74.6298 31.52C75.0098 31.63 75.3898 31.69 75.7698 31.69C76.1298 31.69 76.4098 31.64 76.6098 31.53C76.8098 31.43 76.9098 31.28 76.9098 31.1C76.9098 30.94 76.8198 30.82 76.6398 30.73C76.4598 30.64 76.1798 30.55 75.7998 30.45C75.3698 30.34 75.0198 30.22 74.7298 30.11C74.4498 29.99 74.1998 29.82 73.9998 29.58C73.7898 29.34 73.6898 29.03 73.6898 28.63C73.6898 28.16 73.8198 27.74 74.0798 27.39C74.3398 27.03 74.7098 26.76 75.1898 26.56C75.6698 26.36 76.2298 26.27 76.8698 26.27C77.3398 26.27 77.7798 26.32 78.1898 26.42C78.5998 26.52 78.9498 26.66 79.2498 26.84L78.5698 28.23C78.3098 28.07 78.0298 27.94 77.7098 27.86C77.3998 27.77 77.0798 27.73 76.7498 27.73C76.3798 27.73 76.0898 27.79 75.8698 27.91C75.6598 28.03 75.5498 28.18 75.5498 28.37C75.5498 28.53 75.6398 28.66 75.8198 28.75C75.9998 28.84 76.2898 28.93 76.6698 29.03C77.0998 29.14 77.4498 29.25 77.7298 29.36C78.0098 29.47 78.2498 29.65 78.4498 29.88C78.6498 30.11 78.7498 30.42 78.7498 30.8C78.7498 31.27 78.6198 31.68 78.3598 32.03C78.0998 32.39 77.7298 32.66 77.2398 32.86C76.7598 33.06 76.1998 33.15 75.5598 33.15C75.0298 33.14 74.5098 33.07 74.0198 32.94Z"
      fill="currentColor"
    />
    <path
      d="M16.5698 9.00005L16.1798 10.94H20.9098L20.3298 13.82H15.6198L14.8898 17.45H11.0698L13.3398 6.11005H22.5598L21.9598 9.00005H16.5698Z"
      fill="currentColor"
    />
    <path
      d="M30.4797 15.4801H26.1497L25.0197 17.4601H20.9897L28.2097 6.12006H31.9697L34.6597 17.4601H30.8497L30.4797 15.4801ZM29.9497 12.7201L29.3997 9.82006L27.7297 12.7201H29.9497Z"
      fill="currentColor"
    />
    <path
      d="M49.8499 6.11005L47.5799 17.45H44.4399L41.1799 12.17L40.1299 17.45H36.3999L38.6699 6.11005H41.8099L45.0699 11.39L46.1199 6.11005H49.8499Z"
      fill="currentColor"
    />
    <path
      d="M53.9597 17.07C53.0797 16.64 52.3997 16.05 51.9197 15.28C51.4397 14.51 51.1997 13.63 51.1997 12.64C51.1997 11.32 51.4997 10.15 52.1197 9.12003C52.7297 8.09003 53.5797 7.29003 54.6597 6.71003C55.7497 6.13003 56.9797 5.84003 58.3597 5.84003C59.4497 5.84003 60.4197 6.04003 61.2597 6.43003C62.0997 6.82003 62.7297 7.38003 63.1397 8.11003L60.3897 10.26C59.8797 9.37003 59.1297 8.93003 58.1197 8.93003C57.5297 8.93003 56.9997 9.08003 56.5297 9.37003C56.0697 9.66003 55.6997 10.07 55.4497 10.59C55.1997 11.11 55.0597 11.71 55.0597 12.38C55.0597 13.05 55.2697 13.59 55.6997 13.99C56.1297 14.4 56.6897 14.6 57.3897 14.6C58.3497 14.6 59.1897 14.16 59.9197 13.29L62.1697 15.44C61.5097 16.25 60.7597 16.83 59.9297 17.17C59.0897 17.52 58.1197 17.69 57.0197 17.69C55.8597 17.71 54.8397 17.5 53.9597 17.07Z"
      fill="currentColor"
    />
    <path
      d="M71.2999 13.34L70.4899 17.45H66.6699L67.4999 13.29L64.6699 6.11005H68.5099L70.0499 10.03L73.2099 6.11005H77.0499L71.2999 13.34Z"
      fill="currentColor"
    />
  </svg>
);

export default Logo;
